<template>
    <div>
        <van-nav-bar title="账号详情" left-arrow @click-left="onBack" />

        <!-- 加载中 -->
        <van-loading v-if="loading" type="spinner" color="#1989fa" style="display:flex;justify-content:center;margin-top:40px;" />

        <!-- 无数据 -->
        <van-empty v-else-if="!data" description="这一组账号用完了" />

        <!-- 数据展示 -->
        <div v-else>
            <van-cell-group inset style="margin-top:12px">
                <van-cell title="账号名称" :value="data.AccountName" />
                <van-cell title="绑定号码" :value="data.PhoneNumber" />
                <van-cell title="所属人员" :value="data.LeaderName" />
                <van-cell title="接码过期" :value="data.ExpireDate ? data.ExpireDate.slice(0, 10) : '—'" />
                <van-cell v-if="data.AccountImg" title="账号照片" is-link @click="previewImg">
                    <template #value>
                        <span style="color:#1989fa">点击查看</span>
                    </template>
                </van-cell>
            </van-cell-group>

            <!-- 获取验证码 -->
            <div style="margin:16px 12px 0;">
                <van-button
                    block round
                    type="primary"
                    :loading="smsLoading"
                    loading-text="获取中..."
                    @click="getSms"
                >
                    获取验证码
                </van-button>
            </div>

            <!-- 验证码内容 -->
            <div class="sms-box" :class="{ placeholder: !smsContent }">
                <span>{{ smsContent || '点击按钮获取验证码信息' }}</span>
            </div>

            <!-- 操作按钮 -->
            <div style="margin:16px 12px;display:flex;gap:12px;">
                <van-button
                    block round
                    type="danger"
                    @click="showErrorSheet = true"
                >
                    上号失败
                </van-button>
                <van-button
                    block round
                    type="success"
                    :loading="okLoading"
                    loading-text="提交中..."
                    @click="onOk"
                >
                    上号成功
                </van-button>
            </div>
        </div>

        <!-- 失败原因选择 -->
        <van-action-sheet
            v-model:show="showErrorSheet"
            :actions="errorActions"
            cancel-text="取消"
            close-on-click-action
            @select="onError"
        />
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Toast, ImagePreview } from 'vant';
import { getNextAccountReq, getSmsReq, setOkReq, setErrorReq } from '@/request.js';

export default {
    setup() {
        const route = useRoute();
        const router = useRouter();
        const batchId = route.query.batchId;

        const data = ref(null);
        const loading = ref(false);
        const smsLoading = ref(false);
        const okLoading = ref(false);
        const smsContent = ref('');
        const showErrorSheet = ref(false);

        const errorActions = [
            { name: '无法获取验证码' },
            { name: '淘宝号被封' },
            { name: '密码错误' },
        ];

        const loadData = () => {
            loading.value = true;
            smsContent.value = '';
            getNextAccountReq({ batchId }, (res) => {
                loading.value = false;
                if (res.IsSuccess) {
                    data.value = res.Result;
                    if (!res.Result) {
                        Toast({ message: '这一组账号用完了', position: 'bottom' });
                    }
                }
            });
        };

        const getSms = () => {
            if (!data.value || !data.value.BindPhoneId) return;
            smsLoading.value = true;
            getSmsReq({ phoneId: data.value.BindPhoneId }, (res) => {
                smsLoading.value = false;
                smsContent.value = res.Message;
            });
        };

        const onOk = () => {
            okLoading.value = true;
            setOkReq({ accountId: data.value.AccountId }, (res) => {
                okLoading.value = false;
                if (res.IsSuccess) {
                    Toast.success('已标记成功');
                    loadData();
                }
            });
        };

        const onError = (action) => {
            setErrorReq({ accountId: data.value.AccountId, errorMessage: action.name }, (res) => {
                if (res.IsSuccess) {
                    Toast({ message: '已标记失败：' + action.name, position: 'bottom' });
                    loadData();
                }
            });
        };

        const previewImg = () => {
            ImagePreview([data.value.AccountImg]);
        };

        const onBack = () => router.push({ path: '/index' });

        loadData();

        return {
            data, loading, smsLoading, okLoading,
            smsContent, showErrorSheet, errorActions,
            getSms, onOk, onError, onBack, previewImg,
        };
    }
}
</script>

<style scoped>
.sms-box {
    margin: 10px 12px 0;
    background: #f0f9eb;
    border: 1px solid #b3e19d;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 14px;
    color: #333;
    word-break: break-all;
}
.sms-box.placeholder {
    background: #f7f8fa;
    border-color: #ebedf0;
    color: #999;
}
</style>
